export const sameDayCheckin = (sameDayBooking: number): boolean => {
	const time = new Date();
	const currentHour = time.getHours();
	const currentMinute = time.getMinutes();

	if ((currentHour < 16) && sameDayBooking === 1) {
		return true;
	}
	return false;
};
